import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const PoliticaCookies = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      
      <main className="flex-grow pt-24 pb-16 bg-muted/30">
        <div className="container mx-auto px-4 sm:px-6 max-w-4xl">
          <h1 className="text-4xl sm:text-5xl font-bold text-primary mb-8 font-playfair">
            Politica Cookie-uri
          </h1>
          
          <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground font-lora">
            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">Ce sunt cookie-urile?</h2>
              <p>Cookie-urile sunt fișiere text mici stocate pe dispozitivul dumneavoastră când vizitați un site web.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">Tipuri de Cookie-uri Utilizate</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Cookie-uri esențiale:</strong> Necesare pentru funcționarea site-ului</li>
                <li><strong>Cookie-uri de performanță:</strong> Analizează cum este utilizat site-ul</li>
                <li><strong>Cookie-uri funcționale:</strong> Memorează preferințele utilizatorului</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">Gestionarea Cookie-urilor</h2>
              <p>Puteți gestiona sau șterge cookie-urile prin setările browserului dumneavoastră. Dezactivarea cookie-urilor poate afecta funcționalitatea site-ului.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">Durată de Stocare</h2>
              <p>Cookie-urile esențiale sunt stocate pentru durata sesiunii, în timp ce cookie-urile funcționale pot fi păstrate până la 12 luni.</p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PoliticaCookies;
